// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"c4e8fed4","202":"da8f7186","264":"f11f0ce7","379":"e401e443","386":"4bb28103","467":"5131eb1a","557":"df8813a5","563":"619f43da","585":"a4598f0f","699":"6dd2b67c","722":"561eaec8","757":"923a6751","796":"812c181d","895":"82ddd34a","919":"4df5f9e5","970":"69115af7"}[chunkId] + ".chunk.js";
};